export function getTotalPagesCount(offersPerPage: number, totalOffers: number, maxPage: number | null): number {
  let totalPagesCount = Math.ceil(totalOffers / offersPerPage);

  if (maxPage && maxPage < totalPagesCount) {
    totalPagesCount = maxPage;
  }

  return totalPagesCount;
}
